module.exports = __webpack_public_path__ + "img/yuanpeng.957ae652.jpg";